import { makeStyles } from "@material-ui/core/styles"
import { useTheme } from "@material-ui/core/styles"
import { withComma } from "src/features/Utils/price"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import DeleteIcon from "@material-ui/icons/Delete"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import Paper from "@material-ui/core/Paper"
import Popper from "@material-ui/core/Popper"
import React, { useRef, useState } from "react"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import VisibilityIcon from "@material-ui/icons/Visibility"
import { useSelector, useDispatch } from "react-redux"
import { removeById } from "src/pages/Bundle/List/ducks"
import { push } from "redux-first-history"
const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 400,
    overflow: "auto",
  },
}))

const Card = (props) => {
  const {
    label,
    description,
    cover_uri,
    total_item,
    promo_price,
    id,
    end_date,
  } = props
  const dispatch = useDispatch()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down("xs"))
  const classes = useStyles()
  const thb_price = withComma(`${promo_price}`)
  const ids = useSelector((state) => state.bundle_list.delete_req)
  // popper
  const anchorRef = useRef(null)
  // eslint-disable-next-line
  const [arrowRef, setArrowRef] = useState(null)
  // eslint-disable-next-line
  const [arrow, setArrow] = useState(false)
  const [open, setOpen] = useState(false)
  const loading = ids.includes(id)

  const handleConfirm = async () => {
    await dispatch(removeById(id))
    setOpen(false)
  }

  const handleClickButton = (event) => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClickEdit = () => {
    dispatch(push("bundle/" + id))
  }

  if (matches) {
    return (
      <React.Fragment>
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={4}>
            <Box
              maxWidth="75px"
              maxHeight="75px"
              component="img"
              src={
                cover_uri !== "" ? cover_uri : "https://via.placeholder.com/150"
              }
              alt="pic"
            />
          </Grid>
          <Grid item xs={7}>
            <Typography variant="subtitle1" gutterBottom>
              {label}
            </Typography>
            <Typography variant="subtitle2">{description}</Typography>
          </Grid>
        </Grid>
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={4}>
            <Typography variant="subtitle1">{total_item} items</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle1">฿{thb_price}</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          spacing={1}
        >
          <Grid item>
            <IconButton color="secondary" onClick={handleClickEdit}>
              <VisibilityIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              aria-describedby={id}
              ref={anchorRef}
              color="secondary"
              disabled={!!end_date}
              onClick={handleClickButton}
            >
              <DeleteIcon />
            </IconButton>
            <Popper
              id={id}
              open={open}
              anchorEl={anchorRef.current}
              placement="bottom"
              disablePortal={false}
              modifiers={{
                flip: {
                  enabled: true,
                },
                preventOverflow: {
                  enabled: true,
                  boundariesElement: "scrollParent",
                },
                arrow: {
                  enabled: false,
                  element: arrowRef,
                },
              }}
            >
              <Paper className={classes.paper}>
                <DialogTitle>{`Would you like to cancel this “${label} ” group product?`}</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {`If you confirm, This ${label} will be at the end of today 11:59 pm`}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    disabled={loading}
                    onClick={handleClickButton}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    disabled={loading}
                    onClick={handleConfirm}
                    color="primary"
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Paper>
            </Popper>
          </Grid>
        </Grid>
        <Box my={2}>
          <Divider />
        </Box>
      </React.Fragment>
    )
  } else {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid item sm={2} lg={1}>
            <Box
              maxWidth="80px"
              maxHeight="80px"
              component="img"
              src={
                cover_uri !== "" ? cover_uri : "https://via.placeholder.com/150"
              }
              alt="pic"
            />
          </Grid>
          <Grid item sm={4}>
            <Typography variant="subtitle1" gutterBottom>
              {label}
            </Typography>
            <Typography variant="subtitle2">{description}</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography variant="subtitle1">{total_item} items</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography variant="subtitle1">฿{thb_price}</Typography>
          </Grid>
          <Grid item>
            <IconButton color="secondary" onClick={handleClickEdit}>
              <VisibilityIcon />
            </IconButton>
            <IconButton
              aria-describedby={id}
              ref={anchorRef}
              color="secondary"
              disabled={!!end_date}
              onClick={handleClickButton}
            >
              <DeleteIcon />
            </IconButton>
            <Popper
              id={id}
              open={open}
              anchorEl={anchorRef.current}
              placement="bottom"
              disablePortal={false}
              modifiers={{
                flip: {
                  enabled: true,
                },
                preventOverflow: {
                  enabled: true,
                  boundariesElement: "scrollParent",
                },
                arrow: {
                  enabled: false,
                  element: arrowRef,
                },
              }}
            >
              <Paper className={classes.paper}>
                <DialogTitle>{`Would you like to cancel this “${label} ” group product?`}</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {`If you confirm, This ${label} will be at the end of today 11:59 pm`}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    disabled={loading}
                    onClick={handleClickButton}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    disabled={loading}
                    onClick={handleConfirm}
                    color="primary"
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Paper>
            </Popper>
          </Grid>
        </Grid>
        <Box my={2}>
          <Divider />
        </Box>
      </React.Fragment>
    )
  }
}

export default Card
